export default "__VITE_ASSET__9598cf9a__"